import { IRootState } from 'app/shared/reducers';
import { createSelector } from 'reselect';
import { StepState } from './step.state';

const selectStepState: any = (state: IRootState) => state.step;

export const getNbSteps = createSelector(selectStepState, (stepStore: StepState) => Object.values(stepStore.journeySteps).length);

export const isEndStep = createSelector(selectStepState, (stepStore: StepState) => {
  const currentStep = stepStore.journeyStepsList[stepStore.currentStep - 1];
  return currentStep === 'confirmationStep' || currentStep === 'cancellationStep';
});

export const isTooEarlyStep = createSelector(selectStepState, (stepStore: StepState) => {
  const currentStep = stepStore.journeyStepsList[stepStore.currentStep - 1];
  return currentStep === 'tooEarlyStep';
});

export const nbShowStepActions = createSelector(
  selectStepState,
  (stepStore: StepState) => Object.values(stepStore.journeySteps).filter(step => step.showStepActions).length
);

export const getCurrentStep = createSelector(selectStepState, (stepStore: StepState) => stepStore.currentStep - 1);

export const getPreviousStep = createSelector(selectStepState, (stepStore: StepState) => stepStore.previousStep);

export const getCurrentPageType = createSelector(
  selectStepState,
  (stepStore: StepState) => stepStore.journeySteps[stepStore.journeyStepsList[stepStore.currentStep - 1]]?.cmsType
);

export const getCurrentShowStepActions = createSelector(
  selectStepState,
  (stepStore: StepState) => stepStore.journeySteps[stepStore.journeyStepsList[stepStore.currentStep - 1]]?.showStepActions
);

export const getCurrentComponent = createSelector(
  selectStepState,
  (stepStore: StepState) => stepStore.journeySteps[stepStore.journeyStepsList[stepStore.currentStep - 1]]?.component
);

export const getCurrentJourneyStep = createSelector(
  selectStepState,
  (stepStore: StepState) => stepStore.journeyStepsList[stepStore.currentStep - 1]
);

export const getFirstJourneyStep = createSelector(selectStepState, (stepStore: StepState) => stepStore.journeyStepsList[0]);
